export default __webpack_public_path__ + "static/media/warning--crossroads--g1.14d61769.png";